import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, CardHeader } from "../../../components/card/card";
import NormalInput from "../../../components/form/HorizontalNormalInput";
import Degradation from "./degradation-interactive";
import Opex from "./opex/index";
import Capex from "./capex/index";
import Annualize from "./annualize";
import ConfirmationDlg from "../../../components/ConfirmationDlg";
import { LocationFilter } from "../../../components/LocationFilter";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { matar } from "../../../api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { Loader } from "../../../utils/helper";

function Strategies() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const strategyId = params.get("strategyId");
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [increase, setIncrease] = useState(false);
  const [loading, setLoading] = useState(false);
  const [decrease, setDecrease] = useState(false);
  const [replacement, setReplacement] = useState(false);
  const [refurbishment, setRefurbishment] = useState(false);
  const [increaseData, setIncreaseData] = useState([]);
  const [decreaseData, setDecreaseData] = useState([]);
  const [replacementData, setReplacementData] = useState([]);
  const [refurbishmentData, setRefurbishmentData] = useState([]);
  const [assetPreview, setAssetPreview] = useState("");

  const [valueRandom, setValueRandom] = useState(0);
  const [groups, setGroups] = useState([]);
  const [year, setYear] = useState("2025");
  const [config, setConfig] = useState(["1"]);
  const [selected, setSelected] = useState("");
  const [groupChoosed, setGroupChoosed] = useState("");
  const [strategy, setStrategy] = useState("individual");
  const [allData, setAllData] = useState([]);

  const getOne = async () => {
    setLoading(true);
    const res = await matar.getOneStrategy({ id: strategyId });
    if (res.ok) {
      const body = await res.json();
      const data = body.data;

      const prameters = data.MachineStrategies[0]?.parameters;
      setIncrease(prameters.increase_pm?.length > 0);
      setDecrease(prameters.decrease_pm?.length > 0);
      setReplacement(prameters.replacement?.length > 0);
      setRefurbishment(prameters.refurbishment?.length > 0);
      let inc = [];
      let dec = [];
      let rep = [];
      let ref = [];
      if (prameters.increase_pm?.length > 0) {
        inc = prameters.increase_pm;
        setIncreaseData(prameters.increase_pm);
      } else setIncreaseData([]);
      if (prameters.decrease_pm?.length > 0) {
        dec = prameters.decrease_pm;
        setDecreaseData(prameters.decrease_pm);
      } else setDecreaseData([]);
      if (prameters.replacement?.length > 0) {
        rep = prameters.replacement;
        setReplacementData(prameters.replacement);
      } else setReplacementData([]);
      if (prameters.refurbishment?.length > 0) {
        ref = prameters.refurbishment;
        setRefurbishmentData(prameters.refurbishment);
      } else setRefurbishmentData([]);
      // await for 1 second
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setName(data.name);
      setGroupChoosed(data.group_id);
      setSelected(data.group);
      setAssetPreview(data.MachineStrategies[0]?.machine_id);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!strategyId) {
      setOpen(true);
    } else {
      getOne();
    }
  }, [strategyId]);

  const changePreview = (e) => {
    setAssetPreview(e.target.value);
  };
  const [showSave, setShowSave] = useState(false);
  const recalculateRandom = () => {
    setValueRandom(valueRandom + 1);
  };
  const fixStringToInt = (arr) => {
    const tmp = arr.map((item) => {
      return {
        ...item,
        cost: parseInt(item.cost) || null,
        score: parseFloat(item.score) || null,
        capex: parseInt(item.capex) || null,
        opex: parseInt(item.opex) || null,
        year: parseInt(item.year) || null,
        start: parseInt(item.start) || null,
        duration: parseInt(item.duration) || null,
      };
    });
    //delete null value from the object of array
    const result = tmp.filter((item) => {
      return Object.values(item).some((value) => value !== null);
    });
    return result;
  };
  const simulateData = async () => {
    const result = await matar.calculateMatar({
      asset_id: assetPreview,
      increase_pm: fixStringToInt(increaseData),
      decrease_pm: fixStringToInt(decreaseData),
      replacement: fixStringToInt(replacementData),
      refurbishment: fixStringToInt(refurbishmentData),
    });
    if (result.ok) {
      const body = await result.json();
      const data = body.data.simulation;
      setAllData(data);
      setShowSave(true);
    }
  };
  useEffect(() => {
    if (increase) {
      if (increaseData.length === 0)
        setIncreaseData([
          {
            cost: 1000,
            pattern: "M",
            start: 2025,
            duration: 5,
          },
        ]);
    } else {
      setIncreaseData([]);
    }
    if (decrease) {
      if (decreaseData.length === 0)
        setDecreaseData([
          {
            cost: 1000,
            pattern: "M",
            start: 2025,
            duration: 5,
          },
        ]);
    } else {
      setDecreaseData([]);
    }
    if (replacement) {
      if (replacementData.length === 0)
        setReplacementData([
          {
            capex: 1000,
            year: 2025,
          },
        ]);
    } else {
      setReplacementData([]);
    }
    if (refurbishment) {
      if (refurbishmentData.length === 0)
        setRefurbishmentData([
          {
            year: 2026,
            score: 0.7,
            capex: 10000,
            opex: 1000,
          },
        ]);
    } else {
      setRefurbishmentData([]);
    }
  }, [increase, decrease, replacement, refurbishment]);
  useEffect(() => {
    getGroup();
  }, []);
  useEffect(() => {
    if (assetPreview) simulateData();
  }, [assetPreview]);
  async function getGroup() {
    try {
      const res = await matar.getGroupMatar();
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.length) {
          setGroups(data);
        } else {
          setGroups([]);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }
  const deleteConfig = (index) => {
    const newConfig = config.filter((_, i) => i !== index);
    setConfig(newConfig);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleSubmit = () => {
    if (!name) {
      toast.error("Please enter strategy name");
      return;
    }
    const gr = groups.find((g) => g.id === groupChoosed);
    console.log(gr);
    setAssetPreview(gr?.MachineGroup[0]?.machine_id);
    setOpen(false);
    setSelected(gr);
  };

  const updateIncreaseData = (index, data, name) => {
    setIncreaseData((prev) => {
      const newData = [...prev];
      newData[index][name] = data;
      return newData;
    });
  };
  const addIncrease = () => {
    const newData = [...increaseData];
    newData.push({
      cost: 1000,
      pattern: "M",
      start: 2025,
      duration: 5,
    });
    setIncreaseData(newData);
  };
  const removeIncrease = (index) => {
    const newData = [...increaseData];
    newData.splice(index, 1);
    setIncreaseData(newData);
  };

  const updateDecreaseData = (index, data, name) => {
    setDecreaseData((prev) => {
      const newData = [...prev];
      newData[index][name] = data;
      return newData;
    });
  };
  const addDecrease = () => {
    const newData = [...decreaseData];
    newData.push({
      cost: 1000,
      pattern: "M",
      start: 2025,
      duration: 5,
    });
    setDecreaseData(newData);
  };
  const removeDecrease = (index) => {
    const newData = [...decreaseData];
    newData.splice(index, 1);
    setDecreaseData(newData);
  };

  const updateReplacementData = (index, data, name) => {
    setReplacementData((prev) => {
      const newData = [...prev];
      newData[index][name] = data;
      return newData;
    });
  };
  const addReplacement = () => {
    const newData = [...replacementData];
    newData.push({
      capex: 1000,
      year: "2025",
    });
    setReplacementData(newData);
  };
  const removeReplacement = (index) => {
    const newData = [...replacementData];
    newData.splice(index, 1);
    setReplacementData(newData);
  };

  const updateRefurbishmentData = (index, data, name) => {
    setRefurbishmentData((prev) => {
      const newData = [...prev];
      newData[index][name] = data;
      return newData;
    });
  };

  const addRefurbishment = () => {
    const newData = [...refurbishmentData];
    newData.push({
      year: 2026,
      score: 0.7,
      capex: 10000,
      opex: 1000,
    });
    setRefurbishmentData(newData);
  };

  const removeRefurbishment = (index) => {
    const newData = [...refurbishmentData];
    newData.splice(index, 1);
    setRefurbishmentData(newData);
  };

  const updateData = () => {
    const ids = selected.MachineGroup.map((item) => item.machine_id);
    const data = {
      name: name,
      group_id: groupChoosed,
      financial_strategy_id: strategyId,
      machine_ids: ids,
      param: {
        increase_pm: fixStringToInt(increaseData),
        decrease_pm: fixStringToInt(decreaseData),
        replacement: fixStringToInt(replacementData),
        refurbishment: fixStringToInt(refurbishmentData),
      },
    };
    matar
      .updateBulkSimulation(data)
      .then((res) => {
        if (res.ok) {
          setLoading(false);
          toast.success("Strategy updated successfully");
          setShowSave(false);
        } else {
          setLoading(false);
          toast.error("Failed to update strategy");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        toast.error("Error updating strategy");
      });
  };

  const savingData = () => {
    const ids = selected.MachineGroup.map((item) => item.machine_id);
    const data = {
      name: name,
      group_id: groupChoosed,
      machine_ids: ids,
      param: {
        increase_pm: fixStringToInt(increaseData),
        decrease_pm: fixStringToInt(decreaseData),
        replacement: fixStringToInt(replacementData),
        refurbishment: fixStringToInt(refurbishmentData),
      },
    };
    matar
      .saveBulkSimulation(data)
      .then((res) => {
        if (res.ok) {
          setLoading(false);
          toast.success("Strategy created successfully");
          setShowSave(false);
        } else {
          setLoading(false);
          toast.error("Failed to create strategy");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        toast.error("Error creating strategy");
      });
  };

  return (
    <Card className="bg-theme bg-opacity-10 border-theme  mb-3">
      <ConfirmationDlg
        size={"lg"}
        btnSubmitText={"Confirm"}
        btnCancelText={"Cancel"}
        open={open}
        title={"Create Strategy"}
        onClose={handleClose}
        onSubmit={handleSubmit}
      >
        <h5>Apply Strategy to</h5>
        <div className={"border w-100 border-theme p-1 mb-3"}>
          <select
            className="form-control"
            value={groupChoosed}
            onChange={(e) => setGroupChoosed(e.target.value)}
          >
            <option value=""> - Select Group - </option>
            {groups.map((group, index) => {
              return (
                <option key={index} value={group.id}>
                  {group.name}
                </option>
              );
            })}
          </select>
        </div>
        <NormalInput
          required={true}
          value={name}
          label="Strategy Name"
          placeholder="Strategy Name"
          onchange={(e) => setName(e.target.value)}
        />
      </ConfirmationDlg>
      <CardBody>
        <Loader loading={loading}>
          <div className="row">
            <div className="col-sm-3">
              <div className="d-flex mb-3">
                {!strategyId ? (
                  <button
                    className="btn btn-theme text-black btn-sm "
                    onClick={() => {
                      setOpen(true);
                    }}
                    style={{ marginTop: "22px", marginRight: "10px" }}
                  >
                    Create Strategy
                  </button>
                ) : (
                  <button
                    className="btn btn-theme text-black btn-sm "
                    onClick={() => {
                      navigate("/machine-asset/financial-strategies");
                    }}
                    style={{ marginTop: "22px", marginRight: "10px" }}
                  >
                    Close
                  </button>
                )}
              </div>
              {selected ? (
                <div>
                  <NormalInput
                    required={true}
                    value={name}
                    label="Strategy Name"
                    disabled={true}
                    readonly
                    placeholder="Strategy Name"
                  />
                  <hr />
                  <div className="alert alert-info">
                    This Strategy applied for each individual asset selected.
                  </div>

                  <hr />
                  <div className={"mb-3"}>
                    <b>Opex Strategy</b>
                    <div>
                      <div className="form-check form-check-inline">
                        <input
                          value={increase}
                          onChange={(e) => {
                            setIncrease(e.target.checked);
                          }}
                          checked={increase}
                          className="form-check-input"
                          type="checkbox"
                          id="defaultCheck1"
                          style={{
                            opacity: 1,
                            fontSize: "12px",
                            marginTop: "4px",
                          }}
                        />
                        <label
                          className="form-check-label"
                          style={{ opacity: 1, fontSize: "12px" }}
                          htmlFor="defaultCheck1"
                        >
                          Increase PM
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          value={decrease}
                          onChange={(e) => {
                            setDecrease(e.target.checked);
                          }}
                          checked={decrease}
                          className="form-check-input"
                          type="checkbox"
                          id="defaultCheck2"
                          style={{
                            opacity: 1,
                            fontSize: "12px",
                            marginTop: "4px",
                          }}
                        />
                        <label
                          className="form-check-label"
                          style={{ opacity: 1, fontSize: "12px" }}
                          htmlFor="defaultCheck2"
                        >
                          Decrease PM
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className={"mb-3"}>
                    <b>Capex Strategy</b>
                    <div>
                      <div className="form-check form-check-inline">
                        <input
                          value={replacement}
                          onChange={(e) => {
                            setReplacement(e.target.checked);
                          }}
                          checked={replacement}
                          className="form-check-input"
                          type="checkbox"
                          id="Replacement"
                          style={{
                            opacity: 1,
                            fontSize: "12px",
                            marginTop: "4px",
                          }}
                        />
                        <label
                          className="form-check-label"
                          style={{ opacity: 1, fontSize: "12px" }}
                          htmlFor="Replacement"
                        >
                          Replacement
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          value={refurbishment}
                          checked={refurbishment}
                          onChange={(e) => {
                            setRefurbishment(e.target.checked);
                          }}
                          className="form-check-input"
                          type="checkbox"
                          id="Refrubishment"
                          style={{
                            opacity: 1,
                            fontSize: "12px",
                            marginTop: "4px",
                          }}
                        />
                        <label
                          className="form-check-label"
                          style={{ opacity: 1, fontSize: "12px" }}
                          htmlFor="Refrubishment"
                        >
                          Refurbishment
                        </label>
                      </div>
                    </div>
                  </div>
                  {increase ? (
                    <div>
                      {increaseData.map((item, index) => (
                        <Card className={"mb-3"}>
                          <CardHeader>
                            <div className={"d-flex justify-content-between"}>
                              <div className={"text-theme"}>Increase PM</div>
                              <button
                                className={"btn btn-sm btn-danger"}
                                onClick={() => {
                                  removeIncrease(index);
                                }}
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            </div>
                          </CardHeader>

                          <CardBody>
                            <NormalInput
                              label="Cost Per Event"
                              value={item.cost}
                              onchange={(e) => {
                                updateIncreaseData(
                                  index,
                                  e.target.value,
                                  "cost"
                                );
                              }}
                              placeholder="Cost Per Event"
                            />
                            <div className="form-group mb-3">
                              <label
                                className="form-label"
                                htmlFor="exampleFormControlInput1"
                              >
                                Frequency
                              </label>
                              <select
                                className={`form-control`}
                                onChange={(e) => {
                                  updateIncreaseData(
                                    index,
                                    e.target.value,
                                    "pattern"
                                  );
                                }}
                                value={item.pattern}
                                style={{
                                  width: "100%",
                                  backgroundColor: "#0000007a",
                                }}
                              >
                                <option value="M">Monthly</option>
                                <option value="3M">Quarterly</option>
                                <option value="6M">
                                  Half Yearly (6 Months)
                                </option>
                                <option value="Y">Yearly</option>
                                <option value="2Y">Every 2 Year</option>
                                <option value="3Y">Every 3 Year</option>
                                <option value="4Y">Every 4 Year</option>
                                <option value="5Y">Every 5 Year</option>
                              </select>
                            </div>

                            <div className="row">
                              <div className="col-12">
                                <NormalInput
                                  value={item.start}
                                  onchange={(e) => {
                                    updateIncreaseData(
                                      index,
                                      e.target.value,
                                      "start"
                                    );
                                  }}
                                  label="Year Start"
                                  placeholder="eg. 2025"
                                />
                              </div>
                              <div className="col-12">
                                <NormalInput
                                  value={item.duration}
                                  onchange={(e) => {
                                    updateIncreaseData(
                                      index,
                                      e.target.value,
                                      "duration"
                                    );
                                  }}
                                  label="Duration in Year"
                                  type={"number"}
                                  placeholder="eg. 2"
                                />
                              </div>
                            </div>
                            <hr />
                          </CardBody>
                        </Card>
                      ))}
                      <button
                        className="btn btn-primary btn-sm mb-2"
                        onClick={addIncrease}
                      >
                        Add More Increase PM
                      </button>
                    </div>
                  ) : null}
                  {decrease ? (
                    <div>
                      {decreaseData.map((item, index) => (
                        <Card className={"mb-3"}>
                          <CardHeader>
                            <div className={"d-flex justify-content-between"}>
                              <div className={"text-theme"}>Decrease PM</div>
                              <button
                                className={"btn btn-sm btn-danger"}
                                onClick={() => {
                                  removeDecrease(index);
                                }}
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            </div>
                          </CardHeader>

                          <CardBody>
                            <NormalInput
                              label="Cost Per Event"
                              value={item.cost}
                              onchange={(e) => {
                                updateDecreaseData(
                                  index,
                                  e.target.value,
                                  "cost"
                                );
                              }}
                              placeholder="Cost Per Event"
                            />
                            <div className="form-group mb-3">
                              <label
                                className="form-label"
                                htmlFor="exampleFormControlInput1"
                              >
                                Frequency
                              </label>
                              <select
                                className={`form-control`}
                                onChange={(e) => {
                                  updateDecreaseData(
                                    index,
                                    e.target.value,
                                    "pattern"
                                  );
                                }}
                                value={item.pattern}
                                style={{
                                  width: "100%",
                                  backgroundColor: "#0000007a",
                                }}
                              >
                                <option value="M">Monthly</option>
                                <option value="3M">Quarterly</option>
                                <option value="6M">
                                  Half Yearly (6 Months)
                                </option>
                                <option value="Y">Yearly</option>
                                <option value="2Y">Every 2 Year</option>
                                <option value="3Y">Every 3 Year</option>
                                <option value="4Y">Every 4 Year</option>
                                <option value="5Y">Every 5 Year</option>
                              </select>
                            </div>

                            <div className="row">
                              <div className="col-12">
                                <NormalInput
                                  value={item.start}
                                  onchange={(e) => {
                                    updateDecreaseData(
                                      index,
                                      e.target.value,
                                      "start"
                                    );
                                  }}
                                  label="Year Start"
                                  placeholder="eg. 2025"
                                />
                              </div>
                              <div className="col-12">
                                <NormalInput
                                  value={item.duration}
                                  onchange={(e) => {
                                    updateDecreaseData(
                                      index,
                                      e.target.value,
                                      "duration"
                                    );
                                  }}
                                  label="Duration in Year"
                                  type={"number"}
                                  placeholder="eg. 2"
                                />
                              </div>
                            </div>
                            <hr />
                          </CardBody>
                        </Card>
                      ))}

                      <button
                        onClick={addDecrease}
                        className="btn btn-primary btn-sm mb-2"
                      >
                        Add More Decrese PM
                      </button>
                    </div>
                  ) : null}
                  {replacement ? (
                    <div>
                      {replacementData.map((item, index) => (
                        <Card className={"mb-3"}>
                          <CardHeader>
                            <div className={"d-flex justify-content-between"}>
                              <div className={"d-flex justify-content-between"}>
                                <div className={"text-theme"}>Replacement</div>
                              </div>
                              <button
                                className={"btn btn-sm btn-danger"}
                                onClick={() => {
                                  removeReplacement(index);
                                }}
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            </div>
                          </CardHeader>
                          <CardBody>
                            <NormalInput
                              value={item.capex}
                              onchange={(e) => {
                                updateReplacementData(
                                  index,
                                  e.target.value,
                                  "capex"
                                );
                              }}
                              label="Cost Per Event"
                              placeholder="Cost Per Event"
                            />

                            <NormalInput
                              value={item.year}
                              onchange={(e) => {
                                updateReplacementData(
                                  index,
                                  e.target.value,
                                  "year"
                                );
                              }}
                              label="Year duration"
                              placeholder="eg. 2025"
                            />
                          </CardBody>
                        </Card>
                      ))}
                    </div>
                  ) : null}
                  {refurbishment ? (
                    <div>
                      {refurbishmentData.map((item, index) => (
                        <Card className={"mb-3"}>
                          <CardHeader>
                            <div className={"d-flex justify-content-between"}>
                              <div className={"text-theme"}>Refurbishment</div>
                              <button
                                className={"btn btn-sm btn-danger"}
                                onClick={() => {
                                  removeRefurbishment(index);
                                }}
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            </div>
                          </CardHeader>
                          <CardBody>
                            <NormalInput
                              value={item.capex}
                              onchange={(e) => {
                                updateRefurbishmentData(
                                  index,
                                  e.target.value,
                                  "capex"
                                );
                              }}
                              label="Capex Cost"
                              placeholder="Capex Cost"
                            />

                            <NormalInput
                              value={item.opex}
                              onchange={(e) => {
                                updateRefurbishmentData(
                                  index,
                                  e.target.value,
                                  "opex"
                                );
                              }}
                              label="Opex Cost"
                              placeholder="Opex Cost"
                            />
                            <NormalInput
                              value={item.score}
                              onchange={(e) => {
                                updateRefurbishmentData(
                                  index,
                                  e.target.value,
                                  "score"
                                );
                              }}
                              label="Post Rehabilitation Deterioration Score"
                              placeholder="eg 0.7"
                            />

                            <NormalInput
                              value={item.year}
                              onchange={(e) => {
                                updateRefurbishmentData(
                                  index,
                                  e.target.value,
                                  "year"
                                );
                              }}
                              label="Year"
                              placeholder="eg. 2025"
                            />
                          </CardBody>
                        </Card>
                      ))}

                      <button
                        onClick={addRefurbishment}
                        className="btn btn-primary btn-sm mb-2"
                      >
                        Add More Refurbish Config
                      </button>
                    </div>
                  ) : null}
                  <br />
                  <hr />
                  <div className="d-flex justify-content-end">
                    {strategyId ? (
                      <div>
                        {showSave ? (
                          <button
                            style={{ marginRight: "10px" }}
                            className="btn btn-outline-theme"
                            onClick={() => {
                              if (name === "") {
                                Swal.fire({
                                  icon: "error",
                                  title: "Oops...",
                                  text: "Please fill the strategy name",
                                });
                                return;
                              }
                              setLoading(true);
                              updateData();
                            }}
                          >
                            <i className="fa fa-floppy-disk"></i> Update
                          </button>
                        ) : null}
                      </div>
                    ) : (
                      <div>
                        {showSave ? (
                          <button
                            style={{ marginRight: "10px" }}
                            className="btn btn-outline-theme"
                            onClick={() => {
                              if (name === "") {
                                Swal.fire({
                                  icon: "error",
                                  title: "Oops...",
                                  text: "Please fill the strategy name",
                                });
                                return;
                              }
                              setLoading(true);
                              savingData();
                            }}
                          >
                            <i className="fa fa-floppy-disk"></i> Save
                          </button>
                        ) : null}
                      </div>
                    )}

                    <button
                      className="btn btn-outline-theme"
                      onClick={simulateData}
                    >
                      <i className="fa fa-chart-area"></i> Simulate
                    </button>
                  </div>
                </div>
              ) : null}
            </div>
            {selected ? (
              <div className="col-sm-9">
                <div className={"from-group my-2 w-50"}>
                  <label>Select Asset for Preview : </label>
                  <select
                    value={assetPreview}
                    onChange={changePreview}
                    className={"form-control border-theme text-theme"}
                  >
                    {selected.MachineGroup.map((item, index) => (
                      <option
                        key={index}
                        value={item.machine_id}
                        className={"text-theme"}
                      >
                        {item.machine_id}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={"content matar"}>
                  <Degradation
                    recalculateRandom={valueRandom}
                    allData={allData}
                  />
                  <div className={"page-break"}>
                    <div className="content">
                      <Capex changedValue={valueRandom} allData={allData} />
                      <Opex changedValue={valueRandom} allData={allData} />
                    </div>
                  </div>
                  <div className={"page-break"}>
                    <div className="content">
                      <Annualize changedValue={valueRandom} allData={allData}>
                        {" "}
                      </Annualize>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-sm-9 text-center">
                - Please Select / create strategy to preview -
              </div>
            )}
          </div>
        </Loader>
      </CardBody>
    </Card>
  );
}

export default Strategies;
